<div
  class="login-container"
>
  <div class="text-center v-text-caption">アカウントをお持ちの方</div>
  <button (click)="doNavigate()" class="btn-lighten-5 v-btn theme--dark">
    <span class="v-text bold">ログイン</span>
  </button>
  <!-- <a (click)="navigate('login')" class="text-link"> ログイン </a> -->
</div>
